import { IChatHistory, TGroupedChatHistory } from './types'
import { defaultDateFormat } from 'helper/dates'

export const groupChatHistoryByDate = (
  data: IChatHistory[],
  firstUnreadMessageId: string | null
): TGroupedChatHistory => {
  return data.reduce<TGroupedChatHistory>((grouped, chatHistory) => {
    const label = defaultDateFormat(chatHistory.message.created_at)
    return {
      ...grouped,
      [label]: [
        {
          ...chatHistory,
          // setting flag to display unread label above target message
          firstUnread: chatHistory.message.uuid === firstUnreadMessageId
        },
        ...(grouped[label] || [])
      ]
    }
  }, {})
}
